const URL = `${wbConfig.baseUrl}/vnext/searchApi/graphql`;
export const graphRequest = async(
  queryOrMutation,
  cancellationToken
) => {
  const resp = await fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json'
    },
    body: JSON.stringify(queryOrMutation),
    credentials: 'include',
    signal: cancellationToken
  });

  if (resp.status >= 300) {
    const error = await resp.json();
    const errors = error.errors
      .map((e) => e.message)
      .join('\n');

    throw new Error(errors);
  }

  const data = await resp.json();

  if ('errors' in data) {
    const errors = data.errors
      .map((e) => e.message)
      .join('\n');

    throw new Error(errors);
  }

  return {
    response: resp,
    data: data.data
  };
};
